const allFieldsFilled = (obj: any) =>
  Object.values(obj).every((value) => value !== "" && value !== undefined && value !== null);

export default allFieldsFilled;
